import React, { useState, useRef } from 'react';
import "../assets/css/login.css";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import configModule from '../../config.js';
import axios from "axios";

function ResetPwd() {
    const [showPassword, setShowPassword] = useState(false);
    const [showTab, setShowTab] = useState("forgot");
    const inputs = useRef([]);
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [otp, setOtp] = useState(["", "", "", ""]);
    const config = configModule.config();

    const handleChange = (e, index) => {

        const value = e.target.value.replace(/\D/g, "");

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);

        if (value && index < 3) {
            inputs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const sendOtp = async () => {

        if (!email) {
            return toast.error("Enter Email ID");
        }

        try {

            const res = await fetch(`${config.apiBaseUrl}/forgot-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email })
            });

            const data = await res.json();

            if (data.success) {
                toast.success(data.message);
                setShowTab("otp");
            } else {
                toast.error(data.message);
            }

        } catch {
            toast.error("Something went wrong");
        }
    };

    const verifyOtp = async () => {

        const enteredOtp = otp.join("");

        if (enteredOtp.length !== 4) {
            return toast.error("Enter OTP");
        }

        try {

            const res = await fetch(`${config.apiBaseUrl}/verify-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email,
                    otp: enteredOtp
                })
            });

            const data = await res.json();

            if (data.success) {
                toast.success(data.message);
                setShowTab("resetpwd");
            } else {
                toast.error(data.message);
            }

        } catch {
            toast.error("Something went wrong");
        }

    };

    const resendOtp = async () => {

        try {

            const res = await fetch(`${config.apiBaseUrl}/resend-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email })
            });

            const data = await res.json();

            if (data.success) {
                toast.success("OTP Sent Again");
            } else {
                toast.error(data.message);
            }

        } catch {
            toast.error("Something went wrong");
        }

    };

    const resetPassword = async () => {

        if (!password || !confirmPassword) {
            return toast.error("Enter Password");
        }
    
        if (password !== confirmPassword) {
            return toast.error("Passwords do not match");
        }
    
        try {
    
            const res = await fetch(`${config.apiBaseUrl}/reset-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email,
                    password
                })
            });
    
            const data = await res.json();
    
            if (data.success) {
                toast.success(data.message);
    
                setTimeout(() => {
                    navigate("/");
                }, 1500);
    
            } else {
                toast.error(data.message);
            }
    
        } catch {
            toast.error("Something went wrong");
        }
    
    };

    return (
        <div className='d-center w-100 h-100'>
            <div className="page-wrap">
                <div className="panel-left">
                    <div className="brand">
                        <div className="brand-logo">
                            <div className="brand-icon">
                                <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 3v16h14v-3H7.5V3H4z" fill="#0a1628"></path>
                                    <path d="M4 3h3.5v10H4V3zM15 16h3v3h-3v-3z" fill="rgba(10,22,40,0.3)"></path>
                                </svg>
                            </div>
                            <div className="brand-name">
                                Lexora Holdings
                                <span>Private Limited</span>
                            </div>
                        </div>

                        <h2 className="panel-heading">Your <em>investments,</em><br />at a glance.</h2>
                        <div className="divider-rule"></div>
                        <p className="panel-subtext">Secure, real-time access to your portfolio performance, returns, and investment reports — all in one place.</p>
                    </div>

                    <div className="features">
                        <div className="feature-item"><div className="feature-dot"></div><span>Portfolio performance overview</span></div>
                        <div className="feature-item"><div className="feature-dot"></div><span>Investment returns &amp; statements</span></div>
                        <div className="feature-item"><div className="feature-dot"></div><span>Real-time insights &amp; analytics</span></div>
                        <div className="feature-item"><div className="feature-dot"></div><span>Secure 256-bit encrypted access</span></div>
                    </div>

                    <p className="panel-footer">© 2025 Lexora Holdings Pvt. Ltd., &nbsp;·&nbsp; Confidential</p>
                </div>

                {showTab === "forgot" && (
                    <div className="panel-right">
                        <p className="form-eyebrow">Investor Portal</p>
                        <h1 className="form-title">Forgot Password</h1>

                        <div className="input-group">
                            <label name="investor-id">Email ID</label>
                            <div className="input-wrap w-100">

                                <svg className="input-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="5" r="3" stroke="#0a1628" strokeWidth="1.5"></circle>
                                    <path d="M2 13c0-2.5 2.7-4 6-4s6 1.5 6 4" stroke="#0a1628" strokeWidth="1.5" strokeLinecap="round"></path>
                                </svg>
                                <input type="email"
                                    placeholder="example@gmail.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </div>

                        <button className="btn-login" id="loginBtn" onClick={sendOtp}>
                            <span className="btn-text">Send OTP</span>
                            <span className="spinner"></span>
                        </button>

                        <span className="forgot-link" onClick={() => navigate("/")}>Back to LOGIN</span>

                        <div className="credentials-notice">
                            <svg className="notice-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                            <p><strong>Don't have credentials?</strong> Please contact your designated accountant to receive your Investor ID and password for portal access.</p>
                        </div>

                        <p className="form-copyright">This portal is exclusively for registered investors of Lexora Holdings Pvt. Ltd.<br />Unauthorised access is strictly prohibited.</p>
                    </div>
                )}

                {showTab === "otp" && (
                    <div className="panel-right">
                        <p className="form-eyebrow">Investor Portal</p>
                        <h1 className="form-title">Forgot Password</h1>

                        <div className="input-group">
                            <label name="investor-id">Enter OTP</label>
                            <div className="input-wrap w-100">
                                <div className="otp-container">
                                    {[0, 1, 2, 3].map((i) => (
                                        <input
                                            key={i}
                                            type="text"
                                            maxLength="1"
                                            className="otp-input"
                                            ref={(el) => (inputs.current[i] = el)}
                                            onChange={(e) => handleChange(e, i)}
                                            onKeyDown={(e) => handleKeyDown(e, i)}
                                        />
                                    ))}
                                </div>

                                <a className="forgot-link" onClick={resendOtp}>Resend OTP</a>

                            </div>
                        </div>

                        <button className="btn-login" id="loginBtn" onClick={verifyOtp}>
                            <span className="btn-text" >Verify OTP</span>
                            <span className="spinner"></span>
                        </button>
                        <span className="forgot-link" onClick={() => navigate("/")}>Back to LOGIN</span>

                        <div className="credentials-notice">
                            <svg className="notice-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                            <p><strong>Don't have credentials?</strong> Please contact your designated accountant to receive your Investor ID and password for portal access.</p>
                        </div>

                        <p className="form-copyright">This portal is exclusively for registered investors of Lexora Holdings Pvt. Ltd.<br />Unauthorised access is strictly prohibited.</p>
                    </div>
                )}

                {showTab === "resetpwd" && (
                    <div className="panel-right">
                        <p className="form-eyebrow">Investor Portal</p>
                        <h1 className="form-title">Reset Password</h1>

                        <div className="input-group">
                            <label name="password">Password</label>
                            <div className="input-wrap w-100">
                                <svg className="input-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="#0a1628" strokeWidth="1.5"></rect>
                                    <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" stroke="#0a1628" strokeWidth="1.5" strokeLinecap="round"></path>
                                </svg>
                                <input type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)} placeholder="Enter new password" />
                                <button className="eye-toggle" id="eyeToggle" onClick={() => setShowPassword(!showPassword)} aria-label="Toggle password visibility">
                                    {showPassword ? (
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0a1628"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19C5 19 1 12 1 12a21.77 21.77 0 0 1 5.06-5.94" />
                                            <path d="M9.9 4.24A10.94 10.94 0 0 1 12 5c7 0 11 7 11 7a21.8 21.8 0 0 1-3.17 4.19" />
                                            <path d="M1 1l22 22" />
                                            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                                        </svg>
                                    ) : (
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0a1628"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="input-group">
                            <label name="password">Confirm Password</label>
                            <div className="input-wrap w-100">
                                <svg className="input-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="#0a1628" strokeWidth="1.5"></rect>
                                    <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" stroke="#0a1628" strokeWidth="1.5" strokeLinecap="round"></path>
                                </svg>
                                <input type={showPassword ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Enter confirm password" />
                                <button className="eye-toggle" id="eyeToggle" onClick={() => setShowPassword(!showPassword)} aria-label="Toggle password visibility">
                                    {showPassword ? (
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0a1628"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19C5 19 1 12 1 12a21.77 21.77 0 0 1 5.06-5.94" />
                                            <path d="M9.9 4.24A10.94 10.94 0 0 1 12 5c7 0 11 7 11 7a21.8 21.8 0 0 1-3.17 4.19" />
                                            <path d="M1 1l22 22" />
                                            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                                        </svg>
                                    ) : (
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0a1628"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>

                        <button className="btn-login" id="loginBtn" onClick={resetPassword} >
                            <span className="btn-text" >Reset Password</span>
                            <span className="spinner"></span>
                        </button>
                        <span className="forgot-link" onClick={() => navigate("/")}>Back to LOGIN</span>

                        <div className="credentials-notice">
                            <svg className="notice-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                            <p><strong>Don't have credentials?</strong> Please contact your designated accountant to receive your Investor ID and password for portal access.</p>
                        </div>

                        <p className="form-copyright">This portal is exclusively for registered investors of Lexora Holdings Pvt. Ltd.<br />Unauthorised access is strictly prohibited.</p>
                    </div>
                )}
            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default ResetPwd;
